import { ButtonBase } from './ButtonBase'
import styled from 'styled-components'

export const PrimaryButton = styled(ButtonBase)`
	background: #004054;
	color: #fff;
	border-radius: 4px;
`
